import { debounce } from 'lodash-es'
import template from 'lodash.template'

import React, { Component } from 'react';

import './App.css';

import AldermanLookup from './AldermanLookup'
import Committee from './Committee'
import MemberList from './MemberList'
import NextMeeting from './NextMeeting'
import Section from './Section'
import SelectedWard from './SelectedWard'
import Steps from './StepsParallel'
import WardDetail from './WardDetail'

const REPRESENTATIVES_API_URL = 'https://www.googleapis.com/civicinfo/v2/representatives'


const getRepresentativesAPIURL = (address, apiKey) => `${REPRESENTATIVES_API_URL}?address=${encodeURIComponent(address)}&key=${apiKey}`


const parseWard = divisionId => {
  const bits = divisionId.split('/')
  const wardBits = bits[bits.length - 1].split(':')
  return parseInt(wardBits[wardBits.length - 1], 10)
}


class App extends Component {
  constructor(props) {
    super(props)

    this.containerRef = React.createRef()

    this.state = {
      title: "The path to a cop academy",
      intro: "",
      committees: []
    }

    this.handleSelectAddress = this.handleSelectAddress.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.handleClearWardDetail = this.handleClearWardDetail.bind(this)
    this.handleSelectWardDetail = this.handleSelectWardDetail.bind(this)
  }

  /**
   * Callback for selecting the ward whose information we want to show in
   * detail.
   */
  handleSelectWardDetail(member) {
    this.setState({
      wardDetailMember: member
    })
  }

  /**
   * Callback for components that want to clear the ward detail.
   */
  handleClearWardDetail() {
    this.setState({
      wardDetailMember: null
    })
  }

  handleSelectAddress(address) {
    // Use the Google Civic Information API to get the ward number and alderman name
    const url = getRepresentativesAPIURL(address, process.env.REACT_APP_GOOGLE_API_KEY)

    fetch(url).then(res => res.json()).then(data => {
      const office = data.offices.find(office => office.divisionId.startsWith('ocd-division/country:us/state:il/place:chicago/ward:'))
      if (!office) {
        // TODO: Handle this error state
      }

      const ward = parseWard(office.divisionId)

      if (office.officialIndices.length !== 1) {
        // TODO: Handle this error state
      }

      const alderman = data.officials[office.officialIndices[0]]

      this.setState({
        highlightWard: ward,
        highlightAlderman: alderman
      })
    })
  }

  updateDimensions() {
    this.setState({
      width: this.containerRef.current.offsetWidth
    })
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    const modalBackground = this.state.wardDetailMember ? <div className="ModalBackground" /> : false

    const selectedMember = (this.state.highlightWard && this.state.membersByWard) ? this.state.membersByWard[this.state.highlightWard] : null

    // TODO: Better sizing logic here
    const stepsVizWidth = this.state.width
    const stepsVizHeight = stepsVizWidth > 500 ? 250 : 450

    return (
      <div className="App" ref={this.containerRef}>
        <header>
          <h1 className="App-title">{this.state.title}</h1>
        </header>
        <Section copy={this.state.sectionsBySlug ? this.state.sectionsBySlug.intro : null} />
        <Section copy={this.state.sectionsBySlug ? this.state.sectionsBySlug['your-alderperson'] : null} >
          <AldermanLookup
            onSelectAddress={this.handleSelectAddress}
            intro={this.state.alderman_lookup_intro} />
          <SelectedWard
            ward={this.state.highlightWard}
            alderman={selectedMember}
            emailSubjectTpl={this.state.emailSubjectTpl}
            emailBodyTpl={this.state.emailBodyTpl} />
        </Section>
        <Section copy={this.state.sectionsBySlug ? this.state.sectionsBySlug['power-now'] : null}>
          <Steps steps={this.state.steps} width={stepsVizWidth} height={stepsVizHeight} />

          {['planning', 'zoning', 'budget'].map(slug => {
            return (
              <Committee
                key={slug}
                committee={this.state.committeesBySlug ? this.state.committeesBySlug[slug] : null}
                highlightWard={this.state.highlightWard}
                members={this.state.memberships ? this.state.memberships[slug].map(id => this.state.membersById[id]) : null}
                wards={this.state.wards}
                width={this.state.width}
                onClickWard={this.handleSelectWardDetail}
                emailSubjectTpl={this.state.emailSubjectTpl}
                emailBodyTpl={this.state.emailBodyTpl} />
            )
          })}
        </Section>
        <Section copy={this.state.sectionsBySlug ? this.state.sectionsBySlug['final-vote'] : null}>
          <NextMeeting date_time="Wednesday, March 13, 2019, 10 a.m." loc="City Council Chambers" address="121 N. LaSalle St." />
          <MemberList members={this.state.allMemberIds ? this.state.allMemberIds.map(id => this.state.membersById[id]) : null}
            highlightWard={this.statehighlightWard}
            votes={this.state.votes}
            onClickWard={this.handleSelectWardDetail} />
        </Section>

        {modalBackground}
        <WardDetail
          member={this.state.wardDetailMember}
          onClose={this.handleClearWardDetail}
          emailSubjectTpl={this.state.emailSubjectTpl}
          emailBodyTpl={this.state.emailBodyTpl} />
      </div>
    );
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", debounce(this.updateDimensions, 100));

    fetch(process.env.PUBLIC_URL + '/data.json')
      .then(response => response.json())
      .then(data => {
        const membersByWard = data.council.allMemberIds.reduce((lookup, memberId) => {
          const member = data.council.membersById[memberId]
          return {
             ...lookup,
             [member.ward]: member
          }
        }, {})

        this.setState({
          title: data.title,
          emailSubjectTpl: template(data.emailSubjectTpl),
          emailBodyTpl: template(data.emailBodyTpl),
          membersById: data.council.membersById,
          membersByWard: membersByWard,
          memberships: data.council.committees,
          allMemberIds: data.council.allMemberIds,
          steps: data.steps,
          votes: data.votes,
          sectionsBySlug: data.sections.reduce((lookup, section) => {
            return {
              ...lookup,
              [section.slug]: section
            }
          }, {}),
          committeesBySlug: data.committees.reduce((lookup, committee) => {
            return {
              ...lookup,
              [committee.slug]: committee
            }
          }, {})
        })
      })

    fetch(process.env.PUBLIC_URL + '/wards.geojson')
      .then(response => response.json())
      .then(data => {
        this.setState({
          wards: data
        })
      })
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js